export default __webpack_public_path__ + "static/media/courseLogo.a3ab052e.png";